 
import React, { useState, useEffect } from 'react';
import './TaskCard.css';
import { useDispatch } from 'react-redux';
import { editReview } from '../../actions/appAction';
import { useNavigate } from 'react-router-dom';
import more_icon from '../../assets/icon/more.svg';
import { getSurah, shiftTomorrowToday, deleteReview, postponeToday, postponeAllReview, changeAllSurahToReview, saveSurahAsComplete, getStatistics } from '../../actions/appAction';

function TaskCard({ title, items, click, type }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [popupAction, setPopupAction] = useState(null);
  const [taskList, setTaskList] = useState([]);
  const [taskPopup, setTaskPopup] = useState(false);
  const [showPopupList, setShowPopupList] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [feedback, setFeedback] = useState(null); // {message, type}


  const TODAY_KEY = new Date().toISOString().slice(0, 10);
  const STORAGE_KEY = type === false ? 'doneTasksMemorize' : 'doneTasksReview';


  // Automatically hide feedback after a few seconds
  useEffect(() => {
    if (feedback) {
      const timer = setTimeout(() => setFeedback(null), 7000);
      return () => clearTimeout(timer);
    }
  }, [feedback]);


  // Initialize tasks with extra props: done & sliding
  // useEffect(() => {
  //   if (Array.isArray(items)) {
  //     setTaskList(
  //       items.map(it => ({
  //         ...it,
  //         done: false,
  //         sliding: false,
  //       }))
  //     );
  //   } else {
  //     setTaskList([]);
  //   }
  // }, [items]);

  useEffect(() => {
    if (Array.isArray(items)) {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      // remove records from previous days
      Object.keys(stored).forEach((k) => {
        if (k !== TODAY_KEY) delete stored[k];
      });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      const doneToday = Array.isArray(stored[TODAY_KEY]) ? stored[TODAY_KEY] : [];

      // also check memorize store to avoid duplicates across cards
      const memorizeStore = JSON.parse(localStorage.getItem('doneTasksMemorize') || '{}');
      const memorizeDone = Array.isArray(memorizeStore[TODAY_KEY]) ? memorizeStore[TODAY_KEY] : [];
      const parseMidnight = (d) => {
        if (!d) return null;
        const [y, m, day] = d.split('-').map(Number);
        return new Date(y, m - 1, day);
      };

      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);

      let combined = [...items];
      if (type === false) {
        // merge tasks stored locally but not returned from API
        doneToday.forEach((t) => {
          if (!combined.find((it) => it.review_id === t.review_id)) {
            combined.push(t);
          }
        });
      } else {
        // filter out tasks already marked complete in memorize card
        combined = combined.filter((it) => !memorizeDone.some((d) => d.review_id === it.review_id));
      }
              // merge review tasks from local store so completed ones persist on reload
        doneToday.forEach((t) => {
          if (!combined.find((it) => it.review_id === t.review_id)) {
            combined.push(t);
          }
        });
      
      setTaskList(
        combined
          .map((it) => {
            // const revDate = parseMidnight(it.review_date);
            // const nextDate = parseMidnight(it.next_review_date);
            const dueDate = parseMidnight(it.next_review_date || it.review_date);


            return {
              ...it,
              done: doneToday.some((d) => d.review_id === it.review_id),
              sliding: false,
              late: dueDate && dueDate < todayDate,

            };
          })
          .sort((a, b) => (a.done === b.done ? 0 : a.done ? 1 : -1))
      );
    } else {
      setTaskList([]);
    }
  }, [items]);


  


  // --- 1) Handle checkbox changes
  // const handleCheck = async (index) => {
  //   const task = taskList[index];
  //   const nextDone = !task.done;
  
  //   // Fire the API
  //   await dispatch(editReview({
  //     review_id: task.review_id,
  //     request_type: nextDone ? 'add' : 'remove'
  //   }));
  //   await dispatch(getStatistics());
  
  //   // Immediately toggle done in state
  //   setTaskList(old =>
  //     old
  //       .map((t, i) =>
  //         i === index
  //           ? { ...t, done: nextDone, sliding: false }
  //           : t
  //       )
  //       .sort((a, b) => (a.done === b.done ? 0 : a.done ? 1 : -1))
  //   );
  // };

    // --- 1) Handle checkbox changes
    const handleCheck = async (index) => {
      const task = taskList[index];
      const nextDone = !task.done;
    
      // Fire the API
      await dispatch(editReview({
        review_id: task.review_id,
        request_type: nextDone ? 'add' : 'remove'
      }));
      await dispatch(getStatistics());
    
      // Persist done state for today in localStorage
      const store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      const todayArr = Array.isArray(store[TODAY_KEY]) ? store[TODAY_KEY] : [];
  
      if (nextDone) {
        if (!todayArr.find((t) => t.review_id === task.review_id)) {
          todayArr.push(task);
        }
      } else {
        const idx = todayArr.findIndex((t) => t.review_id === task.review_id);
        if (idx !== -1) {
          todayArr.splice(idx, 1);
        }
      }
      store[TODAY_KEY] = todayArr;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  
      // Immediately toggle done in state
      // setTaskList(old =>
      setTaskList((old) =>
        old
          .map((t, i) =>
            // i === index
            //   ? { ...t, done: nextDone, sliding: false }
            //   : t
            i === index ? { ...t, done: nextDone, sliding: false } : t
          )
          .sort((a, b) => (a.done === b.done ? 0 : a.done ? 1 : -1))
      );
    };
    
  

  // --- 2) Handle end of sliding transition
  const handleTransitionEnd = (task, index) => {
    if (task.sliding && !task.done) {
      // Instead of 'complete', send 'add'
      dispatch(editReview({ review_id: task.review_id, request_type: 'add' }));
      
      // Then set done, sliding false, re-sort the list, etc.
      setTaskList((ts) => {
        const newList = [...ts];
        newList[index] = { ...task, done: true, sliding: false };
        // Sort so done items go to the bottom
        newList.sort((a, b) => (a.done === b.done ? 0 : a.done ? 1 : -1));
        return newList;
      });
    }
  };
  

  // --- 3) Navigate to Quran page
  const goToQuran = (task) => {
    if (!task.pages || task.pages.length === 0) {
      console.log('No pages found in this task:', task);
      return;
    }
    navigate(
      `/quran?pages=${task.pages.join(',')}&page=${task.pages[0]}&start=${task.start_ayah}&end=${task.end_ayah}&id=${task.surah_id}&review_id=${task.review_id}`,      // `/quran?pages=${task.pages.join(',')}&page=${task.pages[0]}&start=${task.start_ayah}&end=${task.end_ayah}&id=${task.surah_id}`,
    );
  };
  const handleSelectTaskPopup = (task) => {
    setTaskPopup(true);
    setShowPopupList(true);
    setSelectedTask(task);
    console.log("Selected task:", task);
  };
  const handleShiftTomorrow = async () => {
    setTaskPopup(false);
    setPopupAction(null)
    const res = await dispatch(shiftTomorrowToday({
      'request_type': 'shift_tomorrow_today',
      'surah_id': selectedTask.surah_id,
      'review_id': selectedTask.review_id
    }));
    dispatch(getSurah());
    dispatch(getStatistics());

    if (res) {
      setFeedback({ type: 'success', message: res.message || 'تمت العملية بنجاح' });
    } else {
      setFeedback({ type: 'error', message: 'حدث خطأ أثناء تنفيذ العملية' });
    }
  }

  const handlePostponing = async () => {
    setTaskPopup(false);
    setPopupAction(null)
    const res = await dispatch(postponeToday({
      'request_type': 'postpone_today',
      'surah_id': selectedTask.surah_id,
      'review_id': selectedTask.review_id
    }));
    dispatch(getSurah());
    dispatch(getStatistics());
    if (res) {
      setFeedback({ type: 'success', message: res.message || 'تمت العملية بنجاح' });
    } else {
      setFeedback({ type: 'error', message: 'حدث خطأ أثناء تنفيذ العملية' });
    }
  }
  const handlePostponingAll = async () => {
    setTaskPopup(false);
    setPopupAction(null)
    const res = await dispatch(postponeAllReview({
      'request_type': 'postpone_all_surah',
      'surah_id': selectedTask.surah_id,
      'review_id': selectedTask.review_id
    }));
    dispatch(getSurah());
    dispatch(getStatistics());

    if (res) {
      setFeedback({ type: 'success', message: res.message || 'تمت العملية بنجاح' });
    } else {
      setFeedback({ type: 'error', message: 'حدث خطأ أثناء تنفيذ العملية' });
    }
  }

  const handleDelleteSurah = async () => {
    setTaskPopup(false);
    setPopupAction(null)
    const res = await dispatch(deleteReview({
      'request_type': 'delete_surah',
      'surah_id': selectedTask.surah_id,
      'review_id': selectedTask.review_id
    }));
    dispatch(getSurah());
    dispatch(getStatistics());

    if (res) {
      setFeedback({ type: 'success', message: res.message || 'تمت العملية بنجاح' });
    } else {
      setFeedback({ type: 'error', message: 'حدث خطأ أثناء تنفيذ العملية' });
    }
  }

  const handleSaveSurahAsComplete = async () => {
    setTaskPopup(false);
    setPopupAction(null)
    const res = await dispatch(saveSurahAsComplete({
      'request_type': 'save_surah_as_complete',
      'surah_id': selectedTask.surah_id,
      'review_id': selectedTask.review_id
    }));
    dispatch(getSurah());
    dispatch(getStatistics());

    if (res) {
      setFeedback({ type: 'success', message: res.message || 'تمت العملية بنجاح' });
    } else {
      setFeedback({ type: 'error', message: 'حدث خطأ أثناء تنفيذ العملية' });
    }
  }
  const handleChangeAllSurahToReview = async () => {
    setTaskPopup(false);
    setPopupAction(null);
    const res = await dispatch(
      changeAllSurahToReview({
        request_type: 'surah_as_review',
        surah_id: selectedTask.surah_id,
        review_id: selectedTask.review_id,
      })
    );
    dispatch(getSurah());
    dispatch(getStatistics());

    if (res) {
      let message = res.message || 'تمت العملية بنجاح';
      if (res.message === 'Surah added as review.') {
        message = 'تمت إضافة السورة إلى المراجعة بنجاح';
      }
      setFeedback({ type: 'success', message });
    } else {
      setFeedback({ type: 'error', message: 'حدث خطأ أثناء تنفيذ العملية' });
    }
  }


  



  return (
    <div className="card-container">
      <h2>{title}</h2>
      {taskList.length === 0 && (
        <p className="no-tasks">لا يوجد مهام لهذا اليوم.</p>
      )}
      <div className="task-list-container">


        {taskList.map((task, i) => (
          <div
            key={task.review_id}
            className={`task-row ${task.done ? 'task-done' : ''} ${task.late ? 'task-late' : ''} ${task.sliding ? 'sliding' : ''}`}

            onTransitionEnd={() => handleTransitionEnd(task, i)}
          >
            {/* <label className="checkbox-container">
              <input
                type="checkbox"
                checked={task.done}
                onChange={() => handleCheck(i)}
              />
              <span className="checkmark" />
            </label> */}

            {/* Click the text => Go to Quran */}
            <span className="task-text" onClick={() => goToQuran(task)}>
              <strong>{task.surah_ar}</strong>&nbsp; 
              | من الآية {task.start_ayah} إلى {task.end_ayah}
            </span>
            <img src={more_icon} alt='more' className='more-icon' onClick={()=> handleSelectTaskPopup(task)} />

          </div>
        ))}
          {
            taskPopup && (
              <div className='overlay-task-popup'>
                <div className='task-popup'>
                  <div className='popup-header'>
                  <h3> سورة {selectedTask?.surah_ar || 'اسم السورة'}</h3>
                    <button className='close-button' onClick={()=> {setPopupAction(null) ; setTaskPopup(false)}}>X</button>
                  </div>
                  {showPopupList && (
                    <ul className='task-popup-list'>
                      <li onClick={()=> setPopupAction('shift_tomorrow_today') || setShowPopupList(false)}>تقديم الحفط القادم</li>
                      <li onClick={()=> setPopupAction('postpone_today') || setShowPopupList(false)}>تاجيل الحفظ هذا فقط</li>
                      <li onClick={ ()=> setPopupAction('surah_as_review') || setShowPopupList(false)}>تحويل السورة كاملة الى مراجعة</li>
                      <li onClick={()=> setPopupAction('save_surah_as_complete')|| setShowPopupList(false)} >حفظ السورة من دون تحويلها الى مراجعة</li>
                      <li onClick={()=> setPopupAction('delete_surah') || setShowPopupList(false)}>حذف السورة</li>
                    </ul>
                    
                  )}
                  {popupAction == 'postpone_today' && (
                    <div className='popup-content'>
                      <p>هل انت متأكد من تاجيل الحفظ هذا للغد فقط؟</p>
                      <div className='buttons-container'>
                        <button className='cancel-button' onClick={()=> setPopupAction(null) || setShowPopupList(true)}>الغاء</button>
                        <button className='confirm-button' onClick={()=> handlePostponing()}>تأكيد</button>
                      </div>
                    </div>
                  )}
                  {popupAction == 'postpone_all_surah' && (
                    <div className='popup-content'>
                      <p>هل انت متأكد من تاجيل الحفظ هذا وكل الحفظ القادم؟</p>
                      <div className='buttons-container'>
                        <button className='cancel-button' onClick={()=> setPopupAction(null)  || setShowPopupList(true)}>الغاء</button>
                        <button className='confirm-button' onClick={()=> handlePostponingAll()}>تأكيد</button>
                      </div>
                    </div>
                  )}
                  {popupAction == 'shift_tomorrow_today' && (
                    <div className='popup-content'>
                      <p>هل انت متأكد من تقديم الحفظ القادم؟</p>
                      <div className='buttons-container'>
                        <button className='cancel-button' onClick={()=> setPopupAction(null)  || setShowPopupList(true)}>الغاء</button>
                        <button className='confirm-button' onClick={()=> handleShiftTomorrow()}>تأكيد</button>
                      </div>
                    </div>
                  )}
                  {popupAction == 'surah_as_review' && (
                    <div className='popup-content'>
                      <p>هل انت متأكد من حفظ السورة كاملة وتحويلها مراجعة فقط؟</p>
                      <div className='buttons-container'>
                        <button className='cancel-button' onClick={()=> setPopupAction(null)  || setShowPopupList(true)}>الغاء</button>
                        <button className='confirm-button' onClick={()=> handleChangeAllSurahToReview()} >تأكيد</button>
                      </div>
                    </div>
                  )}
                  {popupAction == 'save_surah_as_complete'&& (
                    <div className='popup-content'>
                      <p>هل انت متأكد من حفظ السورة بدون تحويلها الى مراجعة؟</p>
                      <div className='buttons-container'>
                        <button className='cancel-button' onClick={()=> setPopupAction(null)  || setShowPopupList(true)}>الغاء</button>
                        <button className='confirm-button' onClick={()=> handleSaveSurahAsComplete()}>تأكيد</button>
                      </div>
                    </div>
                  )}
                  {popupAction == 'delete_surah' && (
                    <div className='popup-content'>
                      <p>هل انت متأكد من حذف السورة؟</p>
                      <div className='buttons-container'>
                        <button className='cancel-button' onClick={()=> setPopupAction(null) || setShowPopupList(true)}>الغاء</button>
                        <button className='confirm-button' onClick={()=> handleDelleteSurah()}>تأكيد</button>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            )
          }

      </div>
      {feedback && (
        <div
          className={`feedback-popup ${
            feedback.type === 'success' ? 'success' : 'error'
          }`}
        >
          {feedback.message}
        {/* </p> */}
        </div>
      )}
        {type === false && (
          <div className="button-container">
            <button className="card-button" onClick={click}>
              اضافة سورة
            </button>
          </div>
        )}
    </div>
  );
}

export default TaskCard;
